import { useMemo } from "react";
import { cx } from "../../utils";
import { ButtonSize } from "../Button";

export const ButtonSkeleton = ({
  size = ButtonSize.BASE,
  className
}: {
  size?: ButtonSize;
  className?: string;
}) => {
  const height = useMemo(() => {
    switch (size) {
      case ButtonSize.BASE:
        return "h-[48px]";
      case ButtonSize.LG:
        return "h-[56px]";
      case ButtonSize.SM:
        return "h-[40px]";
      case ButtonSize.XS:
        return "h-[34px]";
    }
  }, [size]);

  return (
    <div
      className={cx(
        "animate-pulse rounded bg-alpha-100",
        height,
        className || "w-[100px]"
      )}
    />
  );
};
